<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        :block="$vuetify.breakpoint.smAndDown"
        color="success" 
        class="px-10"
        disabled
        v-on="on"
      />
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Bonus Letter Date"
      text="Select date for bonus letter"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-card-title>
            <span>Release bonus letter?</span>
          </v-card-title>
          <v-card-text>
            Selected employees have bonus detected. To release bonus letter, please select the letter date.
            <v-checkbox
              v-model="requestELetter"
            >
              <template v-slot:label>
                <div>
                  e-Letter
                </div>
              </template>
            </v-checkbox>
            <v-menu
              v-if="requestELetter"
              v-model="letterDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="letterDateDisplay"
                  v-validate="'required'"
                  outlined
                  readonly
                  label="Letter Date"
                  :error-messages="errors.collect('letterDateDisplay')"
                  data-vv-name="letterDateDisplay"    
                  data-vv-as="letter date"
                  :class="{
                    'required':!letterDateDisplay
                  }"
                  class="label-position" 
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="letterDate"
                @input="letterDateMenu = false"
              />
            </v-menu>
          </v-card-text>
        </v-container>
      </form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="closeDialog"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Release
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        dataPreparation: null,
        requestELetter: true,
        letterDate: null,
        letterDateMenu: false,
      }
    },
    computed: {
      letterDateDisplay () {
        return this.letterDate ? this.$moment(this.letterDate, 'YYYY-MM-DD').format('DD MMM YYYY') : ''
      },
    },
    methods: {
      toggleDialog (data) {
        this.dataPreparation = data
        this.dialog = true
      },
      closeDialog () {
        this.dialog = false
      },
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payslips().releasePayslip(this.prepareFormData())
              .then(res => {
                this.$emit('released')
                this.$snack({ message: 'Payslip and bonus letter released successfully' })
              })
              .catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to release', 
                })
              })
              .then(() => {
                this.progressing = false
                this.tableLoading = true
              })
          })
      },
      prepareFormData () {
        return {
          employees: this.dataPreparation.employees,
          payroll_period_id: this.dataPreparation.payroll_period_id,
          payroll_cycle_transaction_id: this.dataPreparation.payroll_cycle_transaction_id,
          is_e_letter_sent: this.requestELetter,
          letter_date: this.requestELetter === true ? this.letterDate : null,
        }
      },
    },
  }
</script>

<style scoped>
.label-position >>> .v-label.v-label--active{
  margin-left:-28px;
  background:white;
  padding-right:5px
}
</style>
